import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, CheckCircle2, Clock } from 'lucide-react';
import { CTA } from './ui/Button';
function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 29,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-rose-50 border border-rose-100 rounded-2xl p-6 text-center max-w-md mx-auto mb-8" data-id="element-105">
      <div className="flex items-center justify-center gap-2 text-rose-600 font-bold text-sm uppercase tracking-widest mb-4" data-id="element-106">
        <Clock className="w-4 h-4" data-id="element-107" /> Precio de lanzamiento — Cierra en:
      </div>
      <div className="flex justify-center gap-4 text-3xl font-bold text-navy-900 mb-4 font-serif" data-id="element-108">
        <div className="flex flex-col items-center" data-id="element-109">
          <span data-id="element-110">{format(timeLeft.hours)}</span>
          <span className="text-xs text-slate-500 font-sans font-medium uppercase tracking-widest" data-id="element-111">
            HS
          </span>
        </div>
        <span className="text-rose-300" data-id="element-112">:</span>
        <div className="flex flex-col items-center" data-id="element-113">
          <span data-id="element-114">{format(timeLeft.minutes)}</span>
          <span className="text-xs text-slate-500 font-sans font-medium uppercase tracking-widest" data-id="element-115">
            MIN
          </span>
        </div>
        <span className="text-rose-300" data-id="element-116">:</span>
        <div className="flex flex-col items-center" data-id="element-117">
          <span data-id="element-118">{format(timeLeft.seconds)}</span>
          <span className="text-xs text-slate-500 font-sans font-medium uppercase tracking-widest" data-id="element-119">
            SEG
          </span>
        </div>
      </div>
      <p className="text-sm font-medium text-rose-600 mb-4" data-id="element-120">
        ⚠️ Después sube. No vuelve.
      </p>

      <div className="text-left" data-id="element-121">
        <div className="flex justify-between text-xs font-bold text-slate-500 mb-1 uppercase tracking-wider" data-id="element-122">
          <span data-id="element-123">Cupos al precio actual</span>
          <span className="text-rose-600" data-id="element-124">72%</span>
        </div>
        <div className="h-2 bg-rose-100 rounded-full overflow-hidden" data-id="element-125">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: '72%'
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} className="h-full bg-rose-500 rounded-full" data-id="element-126" />
        </div>
        <p className="text-xs text-slate-500 mt-2 text-center" data-id="element-127">
          72% de los cupos ya fueron tomados
        </p>
      </div>
    </div>;
}
export function PricingCard() {
  return <div className="bg-white rounded-3xl shadow-xl border-2 border-violet-500 overflow-hidden max-w-lg mx-auto relative" data-id="element-128">
      <div className="bg-violet-600 text-white text-center py-2 font-bold text-sm tracking-widest uppercase" data-id="element-129">
        ⭐ Oferta Especial
      </div>
      <div className="p-8 md:p-10" data-id="element-130">
        <h3 className="font-serif text-2xl font-bold text-navy-900 text-center mb-2 uppercase tracking-tight" data-id="element-131">
          Megapack — Psicopedagogía Clínica
        </h3>
        <p className="text-center text-slate-600 font-medium mb-8" data-id="element-132">
          8 módulos + Kit PPI + Kit de herramientas profesionales
        </p>

        <div className="flex flex-col items-center justify-center mb-8" data-id="element-133">
          <span className="text-slate-400 line-through text-xl font-medium mb-1" data-id="element-134">
            $59.980 + extras
          </span>
          <div className="flex items-baseline gap-2" data-id="element-135">
            <span className="text-5xl font-bold text-navy-900 tracking-tighter" data-id="element-136">
              $24.990
            </span>
            <span className="text-xl font-bold text-violet-600" data-id="element-137">ARS</span>
          </div>
          <span className="text-sm font-bold text-teal-600 mt-2 bg-teal-50 px-3 py-1 rounded-full" data-id="element-138">
            Pago único · Acceso de por vida
          </span>
        </div>

        <div className="space-y-4 mb-10" data-id="element-139">
          <h4 className="font-bold text-navy-900 text-sm uppercase tracking-widest mb-4 text-center" data-id="element-140">
            Incluye todo esto
          </h4>
          {['Ebook completo (8 módulos)', 'Kit de PPI para psicopedagogas', 'Kit de herramientas profesionales', 'Recursos editables', 'Material imprimible', 'Acceso de por vida', 'Acceso desde cualquier dispositivo'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-141">
              <CheckCircle2 className="w-5 h-5 text-violet-600 shrink-0" data-id="element-142" />
              <span className="text-slate-700 font-medium" data-id="element-143">{item}</span>
            </div>)}
        </div>

        <CTA className="w-full" href="https://checkout.aula-mater.online/cart/66759304020013:1" data-id="element-144" />
      </div>
    </div>;
}
export function OfferSection() {
  return <section id="oferta" className="py-16 bg-gradient-to-b from-white to-purple-50/50 scroll-mt-8" data-id="element-145">
      <div className="container mx-auto px-4" data-id="element-146">
        <Countdown data-id="element-147" />
        <PricingCard data-id="element-148" />

        <div className="max-w-2xl mx-auto mt-16 text-center" data-id="element-149">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal-100 text-teal-600 mb-6" data-id="element-150">
            <Shield className="w-8 h-8" data-id="element-151" />
          </div>
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-navy-900 mb-4 uppercase tracking-tight" data-id="element-152">
            🛡️ Garantía 7 días — Sin preguntas
          </h3>
          <p className="text-lg text-slate-600" data-id="element-153">
            Probalo sin riesgo.
            <br data-id="element-154" />
            Abrís el material. Lo aplicás. Y si sentís que no era lo que
            esperabas, te devolvemos el dinero.
            <br data-id="element-155" />
            <span className="font-bold text-navy-900 mt-2 block" data-id="element-156">
              Sin vueltas.
            </span>
          </p>
        </div>
      </div>
    </section>;
}